import { fromJS } from "immutable";

import { listShortUrlsActions } from "actions/listShortUrlsActions.js";

const initialState = fromJS({
  isLoading: false,
  hasErrors: false,
  data: [
    {
      id: null,
      code: null,
      name: null,
      link: null
    }
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case listShortUrlsActions.startLoader:
      return state.set("isLoading", true);
    case listShortUrlsActions.reset:
      return initialState;
    case listShortUrlsActions.success:
      return state.merge({
        isLoading: false,
        hasErrors: false,
        data: fromJS(action.payload.data)
      });
    case listShortUrlsActions.failure:
      return state.merge({
        isLoading: false,
        hasErrors: true,
        data: fromJS(action.payload.data)
      });
    default:
      return state;
  }
};
